import { extractSmartOrderParams, SmartOrderParams } from '@/utils/smart-order';
import { useMemo } from 'react';

// Reads the LIVE URL after boot. If this flow gains/renames a query param,
// add it to RESERVED_BOOT_QUERY_KEYS (domain/microproducts/boot-params.web)
// so storefront URL writes stay suppressed while it's in play.
export const useSmartOrderParams = (): SmartOrderParams | null => {
  return useMemo(() => {
    const query = Object.fromEntries(
      new URLSearchParams(window.location.search),
    );

    return extractSmartOrderParams(query);
  }, []);
};
